import { atom } from "jotai";

export const isAuthenticatedAtom = atom(null);
export const showLoginAtom = atom(false);
export const authScreenAtom = atom("AUTHENTICATION"); // AUTHENTICATION | EXAM_PREF
export const authUserAtom = atom(null);
export const authActionAtom = atom(null);
